export const OTHER_ERRORS = 0
export const NOT_TENANT = 4
export const SENT_VIA_MAIL = 7
export const SENT_VIA_KIVRA = 8
